import { Link, Outlet, useMatch } from 'react-router-dom';
import { Tabs, Typography, Wrapper } from '@screentone/core';

import { useConvertedProperty } from 'hooks';

const TAB_TITLES = {
  '': 'Layouts',
  'section-parameters': 'Section Parameters',
  general: 'General',
} as const;

type TabValue = keyof typeof TAB_TITLES;

function SiteConfigLayouts() {
  const currentProperty = useConvertedProperty();

  const tabMatch = useMatch('/:property/site-config/layouts/:tab');
  const tabParam = tabMatch?.params.tab ?? '';
  const activeTab: TabValue = tabParam in TAB_TITLES ? (tabParam as TabValue) : '';

  const basePath = `/${currentProperty ?? ''}/site-config/layouts`;

  return (
    <>
      <Typography variant="header2" margin={{ bottom: 'sm' }}>
        {TAB_TITLES[activeTab]}
      </Typography>
      <Tabs role="tablist" value={activeTab} margin={{ top: 'lg' }}>
        <Tabs.Item
          role="tab"
          id="tab-layouts"
          aria-controls="tabpanel-layouts"
          componentEl={Link}
          to={basePath}
          value=""
        >
          {TAB_TITLES['']}
        </Tabs.Item>
        <Tabs.Item
          role="tab"
          id="tab-section-parameters"
          aria-controls="tabpanel-layouts"
          componentEl={Link}
          to={`${basePath}/section-parameters`}
          value="section-parameters"
        >
          {TAB_TITLES['section-parameters']}
        </Tabs.Item>
        <Tabs.Item
          role="tab"
          id="tab-general"
          aria-controls="tabpanel-layouts"
          componentEl={Link}
          to={`${basePath}/general`}
          value="general"
        >
          {TAB_TITLES.general}
        </Tabs.Item>
      </Tabs>
      <Wrapper id="tabpanel-layouts" role="tabpanel" padding={{ top: 'sm' }}>
        <Outlet />
      </Wrapper>
    </>
  );
}

export default SiteConfigLayouts;
